import React, { useState } from 'react';
import {
  Box, Button, FormControl, FormLabel, Input, Heading,
  VStack, useToast, Text, Spinner,
  Stack,
  Link
} from '@chakra-ui/react';
import axios from 'axios';
import { handleLogIn, logIn, signUp } from '../services/account';
import { employeeAcceptInvite } from '../hooks/employees';
import { useNavigate, useParams } from 'react-router-dom';
import SignUpPage from './SignupOnInvitePage';
import SignInPage from './SignInOnInvite';

type Step = 'signup' | 'login' | 'enterToken' | 'done';

export default function AcceptInvitePage() {
    const { orgId, inviteCode } = useParams();
  const toast = useToast();
  const [step, setStep] = useState<Step>('signup');

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userToken, setUserToken] = useState<string | null>(null);

  const API_BASE = 'http://127.0.0.1:8000';

  const handleSignupInternal = async () => {
    // setLoading(true);
    setStep('login');
  };

  const handleLoginInternal = async () => {
    // setLoading(true);
    setStep('enterToken');
  };

  const handleJoinOrganization = async () => {
    setLoading(true);
    if(orgId &&inviteCode){
        let response = await employeeAcceptInvite(inviteCode, orgId);
        if(response.success===true){
            alert('You have successfully joined the organization.');
            navigate('/home');
        }else{
            alert(`An error occured ${response?.data}`);
            navigate('/home');
        }
    }
    
  };

  const renderForm = () => {
    if (step === 'signup') {
      return (
        <>
            <SignUpPage onSignUpProcessDone={handleSignupInternal} />
            <Stack pt={4}>
            <Text align="center">
              Already a user?{' '}
              <Link color="#006400" onClick={()=>{ setStep('login')}}>
                Log in
              </Link>
            </Text>
          </Stack>
        </>
      );
    }

    if (step === 'login') {
      return (
        <>
            <SignInPage onSignInProcessDone={handleLoginInternal} />
            <Stack pt={4}>
                <Text align="center">
                Do not have an account?{' '}
                <Link color="#006400" onClick={()=>{ setStep('signup')}}>
                    Sign Up
                </Link>
                </Text>
            </Stack>
        </>
        
      );
    }

    if (step === 'enterToken') {
      return (
        <>
          <Heading textAlign={'center'} size="md">Accept Invite to Join Organization as Staff</Heading>
          <Button bg={'#006400'} colorScheme="green" onClick={handleJoinOrganization} isLoading={loading}>
            Accept Invite
          </Button>
        </>
      );
    }

    return (
      <>
        <Heading size="md" color="green.600">You're all set!</Heading>
        <Text mt={4}>You’ve successfully joined your organization.</Text>
      </>
    );
  };

  return (
    <Box maxW="md" mx="auto" mt={10} p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <VStack spacing={5} align="stretch">
        {renderForm()}
        {loading && <Spinner />}
      </VStack>
    </Box>
  );
}
